export default [
  {
    path: "noviceTasks",
    name: "noviceTasks",
    meta: {
      title: "noviceTasks"
    },
    component: () =>
      import("@/views/Home/NoviceTasks/NoviceTasks/index.vue")
  },
];
